// extracted by mini-css-extract-plugin
export var addButton = "_mr-0";
export var border = "_mr-8";
export var check = "_mr-h";
export var danger = "_mr-6";
export var dropdownContainer = "_mr-1";
export var editModalBody = "_mr-j";
export var footerContainer = "_mr-i";
export var fullWidth = "_mr-a";
export var hide = "_mr-9";
export var icon = "_mr-3";
export var input = "_mr-7";
export var inputFlex = "_mr-b";
export var inputWrapper = "_mr-c";
export var manualFocus = "_mr-5";
export var optionButton = "_mr-4";
export var pillWrapper = "_mr-e";
export var pointer = "_mr-2";
export var showOverflow = "_mr-f";
export var tagsFlex = "_mr-d";
export var xButton = "_mr-g";